import React, { useRef } from 'react';
import { TextField, TextFieldProps, InputAdornment, IconButton } from '@mui/material';
import { AccessTime, CalendarMonth } from '@mui/icons-material';

export type NativePickerFieldProps = TextFieldProps & {
  type: 'time' | 'datetime-local' | 'date';
};

export const NativePickerField: React.FC<NativePickerFieldProps> = ({ type, InputProps, ...props }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleOpenPicker = (e: React.MouseEvent) => {
    e.preventDefault();
    if (inputRef.current && typeof inputRef.current.showPicker === 'function') {
      try {
        inputRef.current.showPicker();
      } catch (err) {
        console.warn('Native picker could not be opened programmatically on this browser.');
      }
    }
  };

  const Icon = type === 'time' ? AccessTime : CalendarMonth;

  return (
    <TextField
      {...props}
      type={type}
      inputRef={inputRef}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton 
              size="small" 
              onClick={handleOpenPicker}
              edge="end"
              disabled={props.disabled}
            >
              <Icon fontSize="small" />
            </IconButton>
            {InputProps?.endAdornment}
          </InputAdornment>
        )
      }}
      sx={{
        '& input[type="time"]::-webkit-calendar-picker-indicator, & input[type="datetime-local"]::-webkit-calendar-picker-indicator, & input[type="date"]::-webkit-calendar-picker-indicator': {
          display: 'none',
          WebkitAppearance: 'none'
        },
        ...props.sx
      }}
    />
  );
};
